class BlackFridayHero {
  constructor(container) {
    this.container = container;
    this.countdownEndDate = null;
    this.timerInterval = null;

    this.init();
  }

  init() {
    this.setupCountdown();
    this.startTimer();
    this.initCTAButton();
    this.bindThemeEditorEvents();
  }

  initCTAButton() {
    const ctaButton = this.container.querySelector('.w-blackfriday-hero__button');
    if (!ctaButton) return;

    ctaButton.addEventListener('click', (e) => {
      e.preventDefault();

      const firstAtcBundle = document.querySelector('.atc-bundle-sor');
      if (firstAtcBundle) {
        firstAtcBundle.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }

  setupCountdown() {
    const countdownEnd = this.container.dataset.countdownEnd;
    if (!countdownEnd) return;

    this.countdownEndDate = new Date(countdownEnd);

    if (isNaN(this.countdownEndDate.getTime())) {
      console.error('Invalid countdown end date format');
      return;
    }
  }

  startTimer() {
    if (!this.countdownEndDate) return;

    this.updateTimer();

    this.timerInterval = setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  updateTimer() {
    const now = new Date();
    const distance = this.countdownEndDate - now;

    if (distance < 0) {
      this.stopTimer();
      this.showExpiredState();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.updateTimerDisplay('days', days);
    this.updateTimerDisplay('hours', hours);
    this.updateTimerDisplay('minutes', minutes);
    this.updateTimerDisplay('seconds', seconds);
  }

  updateTimerDisplay(unit, value) {
    const element = this.container.querySelector(`[data-timer="${unit}"]`);
    if (element) {
      element.textContent = String(value).padStart(2, '0');
    }
  }

  showExpiredState() {
    const timerBoxes = this.container.querySelectorAll('[data-timer]');
    timerBoxes.forEach(box => {
      box.textContent = '00';
    });
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  bindThemeEditorEvents() {
    if (typeof Shopify === 'undefined' || !Shopify.designMode) return;

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(this.container)) {
        this.stopTimer();
        this.init();
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(this.container)) {
        this.stopTimer();
      }
    });
  }

  destroy() {
    this.stopTimer();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.w-blackfriday-hero');
  sections.forEach(section => {
    new BlackFridayHero(section);
  });
});
